export const API_ENDPOINT = 'health';


// WEBPACK FOOTER //
// ./src/state/modules/system-status/configurations/endpoints.js